import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import { useEntityContext } from "../../../context/EntityContext";
import { useTableContext } from "../../../context/TableContext";
import EntityEditor from "./EntityEditor";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import Loader from "../../../Layouts/Loader/Loader";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";

const EntityMainSection = ({ file }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [activitiesData, setActivitiesData] = useState({});

  const { setEntityUniqueField, setSelectedEntitySm, setEntityInitData, setSmTriggerJobData, setAllProCode } =
    useEntityContext();
  const { getTableTypeData } = useTableContext();
  const allFieldsObject = useRef({});

  const { entityId } = useParams();

  const fetchSingleEntity = async () => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance.get(`/entity/${file.id}`);
      let { data: smData } = await axiosInstance.get(`/state-machine/${data.sm_id}`);
      smData = smData.config;
      const tableData = await getTableTypeData("entity", smData.id);
      const initActivityData = smData.activities.find((act) => act.type === "init");
      setActivitiesData(initActivityData);
      setSelectedEntitySm({
        id: initActivityData.id,
        name: initActivityData.name,
        stateid: smData.id,
        statename: "activities"
      });
      allFieldsObject.current = { ...tableData.tableObject };

      setEntityUniqueField(data.unique_fields);
      setAllProCode(smData.pro_code);
      setSmTriggerJobData(smData.sm_trigger_job || []);

      // for init activity
      setEntityInitData({
        jobs_trigger: initActivityData.jobs_trigger || [],
        activity_owner_assignment: initActivityData.activity_owner_assignment,
        state_change_logic: initActivityData.state_change_logic,
        pre_activity_job: initActivityData.pre_activity_job || [],
        pre_submission: initActivityData.pre_submission || [],
        jobs_trigger_formula: initActivityData.jobs_trigger_formula,
        activity_response: initActivityData.activity_response,
        description: initActivityData.description
      });
    } catch (error) {
      handleApiError(error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (file.id && file.id === entityId) {
      fetchSingleEntity();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  return <EntityEditor file={file} activitiesData={activitiesData} allFieldsObject={allFieldsObject} />;
};

export default EntityMainSection;
